import * as Dialog from "@radix-ui/react-dialog";

import { Button } from "react-migration/components/Button";
import clsx from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export type SwitchWorkspaceModalProps = {
  open: boolean;
  workspaceTitle: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function SwitchWorkspaceModal({ open, workspaceTitle, onCancel, onConfirm }: SwitchWorkspaceModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog.Root open={open}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-100 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          className={clsx(
            "fixed inset-0 z-100 flex flex-col items-center justify-center p-6 outline-none",
            "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          )}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            onCancel();
          }}
          onPointerDownOutside={(e) => e.preventDefault()}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <div className="w-full max-w-md rounded-lg bg-white p-4 shadow-lg border border-border-action flex flex-col gap-4">
            <Dialog.Title className="text-lg font-semibold text-text-base-primary m-0">
              {t("global_search.switch_workspace_modal.title")}
            </Dialog.Title>
            <Dialog.Description className="mt-3 text-sm text-text-base-secondary m-0">
              {t("global_search.switch_workspace_modal.description_line1")}
              <br />
              {t("global_search.switch_workspace_modal.description_question_before")}
              <span className="font-bold">{workspaceTitle}</span>
              {t("global_search.switch_workspace_modal.description_question_after")}
            </Dialog.Description>
            <div className="flex flex-row justify-end gap-3">
              <Button variant="tertiary" size="md" type="button" onClick={onCancel}>
                {t("global_search.switch_workspace_modal.cancel")}
              </Button>
              <Button variant="primary" size="md" type="button" onClick={onConfirm}>
                {t("global_search.switch_workspace_modal.confirm")}
              </Button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
